// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* table tr:nth-child(even) {
  background-color: #dfdbdbbb;
} */
td, th {
  border-right: 1px solid #ccc; /* Add a solid gray border on the right side of each table cell */
  padding: 4px 6px;
}

td:last-child, th:last-child {
  border-right: none; /* Remove the border on the right side of the last table cell in each row and header */
}
.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100px; /* 控制其他列的宽度，可根据需要调整 */
  }
  
  .concept-column {
    width: 40%; /* 设置“所属概念”列占比30% */
  }
  
  .collapsed {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    max-width: 100%; /* 控制初始状态显示的最大宽度 */
  }
  
  .expanded {
    white-space: normal;
    max-width: none; /* 展开时不限制宽度 */
    overflow: visible; /* 确保全部内容可见 */
  }
  
  .expand-button {
    background: none;
    border: none;
    color: #007bff;
    cursor: pointer;
    position: absolute; /* 绝对定位以放置在单元格的右侧 */
    right: 10px; /* 与单元格右侧保持一定距离 */
   
    font-size: 12px; /* 调整按钮字体大小 */
  }
  
.red-row {
  background-color: #f8d7da; /* 红色背景 */
  color: #721c24; /* 红色文本 */
}
.red-text {
  color: red;
}
.green-text {
  color: green;
}

.candlestick-chart-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  position: fixed; /* 固定位置 */
  top: 50%; /* 从顶部50%开始 */
  left: 50%; /* 从左侧50%开始 */
  transform: translate(-50%, -50%); /* 将元素向上和向左移动自身的宽高的一半，实现居中 */
  background-color: white; /* 设置背景色，视需要可调整 */
  border: 1px solid #ccc; /* 边框样式 */
  padding: 20px; /* 内边距 */
  z-index: 1000; /* 确保在最上层 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
}

/* 样式调整 */
.hqchart-tooltip {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);  /* 使元素相对于其自身大小在屏幕中央 */
  background-color: rgba(0, 0, 0, 0.7);  /* 半透明的背景 */
  color: white;
  padding: 20px 30px;  /* 适当的内边距 */
  border-radius: 5px;
  font-size: 18px;
  z-index: 9999;  /* 确保它在页面的最上层 */
  display: none;  /* 初始时隐藏 */
}

/* 显示时的样式 */
.hqchart-tooltip.show {
  display: block;
}


`, "",{"version":3,"sources":["webpack://./src/components/StockTable.css"],"names":[],"mappings":"AAAA;;GAEG;AACH;EACE,4BAA4B,EAAE,iEAAiE;EAC/F,gBAAgB;AAClB;;AAEA;EACE,kBAAkB,EAAE,sFAAsF;AAC5G;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB,EAAE,qBAAqB;EACzC;;EAEA;IACE,UAAU,EAAE,mBAAmB;EACjC;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,eAAe,EAAE,kBAAkB;EACrC;;EAEA;IACE,mBAAmB;IACnB,eAAe,EAAE,aAAa;IAC9B,iBAAiB,EAAE,aAAa;EAClC;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,kBAAkB,EAAE,mBAAmB;IACvC,WAAW,EAAE,iBAAiB;;IAE9B,eAAe,EAAE,aAAa;EAChC;;AAEF;EACE,yBAAyB,EAAE,SAAS;EACpC,cAAc,EAAE,SAAS;AAC3B;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB,EAAE,SAAS;EAClC,mBAAmB,EAAE,SAAS;EAC9B,eAAe,EAAE,SAAS;EAC1B,QAAQ,EAAE,aAAa;EACvB,SAAS,EAAE,aAAa;EACxB,gCAAgC,EAAE,4BAA4B;EAC9D,uBAAuB,EAAE,iBAAiB;EAC1C,sBAAsB,EAAE,SAAS;EACjC,aAAa,EAAE,QAAQ;EACvB,aAAa,EAAE,WAAW;EAC1B,yCAAyC,EAAE,WAAW;AACxD;;AAEA,SAAS;AACT;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC,GAAG,qBAAqB;EACxD,oCAAoC,GAAG,WAAW;EAClD,YAAY;EACZ,kBAAkB,GAAG,WAAW;EAChC,kBAAkB;EAClB,eAAe;EACf,aAAa,GAAG,eAAe;EAC/B,aAAa,GAAG,UAAU;AAC5B;;AAEA,WAAW;AACX;EACE,cAAc;AAChB","sourcesContent":["/* table tr:nth-child(even) {\n  background-color: #dfdbdbbb;\n} */\ntd, th {\n  border-right: 1px solid #ccc; /* Add a solid gray border on the right side of each table cell */\n  padding: 4px 6px;\n}\n\ntd:last-child, th:last-child {\n  border-right: none; /* Remove the border on the right side of the last table cell in each row and header */\n}\n.ellipsis {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100px; /* 控制其他列的宽度，可根据需要调整 */\n  }\n  \n  .concept-column {\n    width: 40%; /* 设置“所属概念”列占比30% */\n  }\n  \n  .collapsed {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: inline-block;\n    max-width: 100%; /* 控制初始状态显示的最大宽度 */\n  }\n  \n  .expanded {\n    white-space: normal;\n    max-width: none; /* 展开时不限制宽度 */\n    overflow: visible; /* 确保全部内容可见 */\n  }\n  \n  .expand-button {\n    background: none;\n    border: none;\n    color: #007bff;\n    cursor: pointer;\n    position: absolute; /* 绝对定位以放置在单元格的右侧 */\n    right: 10px; /* 与单元格右侧保持一定距离 */\n   \n    font-size: 12px; /* 调整按钮字体大小 */\n  }\n  \n.red-row {\n  background-color: #f8d7da; /* 红色背景 */\n  color: #721c24; /* 红色文本 */\n}\n.red-text {\n  color: red;\n}\n.green-text {\n  color: green;\n}\n\n.candlestick-chart-container {\n  display: flex;\n  justify-content: center; /* 水平居中 */\n  align-items: center; /* 垂直居中 */\n  position: fixed; /* 固定位置 */\n  top: 50%; /* 从顶部50%开始 */\n  left: 50%; /* 从左侧50%开始 */\n  transform: translate(-50%, -50%); /* 将元素向上和向左移动自身的宽高的一半，实现居中 */\n  background-color: white; /* 设置背景色，视需要可调整 */\n  border: 1px solid #ccc; /* 边框样式 */\n  padding: 20px; /* 内边距 */\n  z-index: 1000; /* 确保在最上层 */\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */\n}\n\n/* 样式调整 */\n.hqchart-tooltip {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);  /* 使元素相对于其自身大小在屏幕中央 */\n  background-color: rgba(0, 0, 0, 0.7);  /* 半透明的背景 */\n  color: white;\n  padding: 20px 30px;  /* 适当的内边距 */\n  border-radius: 5px;\n  font-size: 18px;\n  z-index: 9999;  /* 确保它在页面的最上层 */\n  display: none;  /* 初始时隐藏 */\n}\n\n/* 显示时的样式 */\n.hqchart-tooltip.show {\n  display: block;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
